var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45059 4.6V1H6.07031",
    stroke: "#E09200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5209 4.59998H4.38008C3.44664 4.59998 2.68994 5.40586 2.68994 6.39998V13.6C2.68994 14.5941 3.44664 15.4 4.38008 15.4H14.5209C15.4544 15.4 16.2111 14.5941 16.2111 13.6V6.39998C16.2111 5.40586 15.4544 4.59998 14.5209 4.59998Z",
    stroke: "#E09200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.99998H2.69014M16.2113 9.99998H17.9014M11.9859 9.09998V10.9M6.91549 9.09998V10.9",
    stroke: "#E09200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBot);
export default __webpack_public_path__ + "static/media/yellowBot.9e75fedae5608df9fef9425f229b51b2.svg";
export { ForwardRef as ReactComponent };